'use strict';
var utils = require('../util');

/**
 * Dynamic Impression tracking for PLP Product Tiles
*/
function dynamicImpressionTracking() {
	if ('IntersectionObserver' in window) {
		let $el = $('.product-tile-view-track');
		$el.each(function () {
			$el = $(this);
			if (!$el.attr('data-viewed')) {
				const config = {
					rootMargin: '0px 0px 0px 0px',
					threshold: 0
				};
				let observer = new IntersectionObserver((entries, self) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							let $this = $(entry.target);
							var productId = $this.find('.product').data('pid');
							let gtmData = $this.find('.pdp-link a').data('gtm-data');
							if(productId && productId.indexOf('STL') > -1) {
								let shopThelookObj = {shopTheLookID : productId};
								Object.assign(gtmData, shopThelookObj);
							}
							let categoryName = $('#categoryName').val();
							let listObject = {list : categoryName};
							Object.assign(gtmData, listObject);
							$(document).trigger('productTile:trackDynamicImpression', { gtmData: gtmData });
							self.unobserve(entry.target);
							$this.attr('data-viewed', true);
						}
					});
				}, config);
				observer.observe($el[0]);
			}
		});
	}
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
	var $updates = $results.find(selector);
	$(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
	$('.refinement.active').each(function () {
		$(this).removeClass('active');
		var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
		activeDiv.addClass('active');
		activeDiv.find('button.title').attr('aria-expanded', 'true');
	});

	updateDom($results, '.refinements');
	preExpandFilters();
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response, applyFilter) {
	var $results = $(response);
	var specialHandlers = {
		'.refinements': handleRefinements
	};

	var isMobile = $('#isMobile').val();
	var productSet = [];
	var applyFilterOnMobileViewport = ((isMobile === 'true' && $(window).width() <= 768) && !applyFilter && parseInt($results.find('#apply-filter').data('selected-count')) > 0);
	if (applyFilterOnMobileViewport) {
		productSet = [
			'.header-bar',
			'.header.page-title',
			'.filter-bar',
			'.mobile-result-count'
		];
	} else {
		// Update DOM elements that do not require special handling
		productSet = [
			'.grid-header',
			'.header-bar',
			'.header.page-title',
			'.product-grid.plp',
			'.show-more',
			'.filter-bar',
			'.mobile-result-count'
		];
	}

	productSet.forEach(function (selector) {
		updateDom($results, selector);
	});

	Object.keys(specialHandlers).forEach(function (selector) {
		specialHandlers[selector]($results);
	});

	if (!applyFilterOnMobileViewport) {
		utils.enhancingSelectDropdown(true);
		dynamicImpressionTracking();
	}
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
	var showMoreUrl = $element.data('url');
	$.spinner().start();
	$.ajax({
		url: showMoreUrl,
		method: 'GET',
		success: function (response) {
			$target.append(response);
			$.spinner().stop();
		},
		error: function () {
			$.spinner().stop();
		}
	});
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
	var $tempDom = $('<div>').append($(response));
	var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
	sortOptions.forEach(function (option) {
		$('option.' + option.id).val(option.url);
	});
}

function browserandVersion(){
	var ua = navigator.userAgent, tem,
		M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	tem = ua.match(/version\/(\d+)/i);
	if ( tem != null)
		M.splice(1, 1, tem[1]);
	
	return M.join(':');
}

function browserVersionPrecision(agent){
	var ua = navigator.userAgent,
		tem, userBrowser =[], 
		browser = agent.split(':');
	var ub = browser[0].toLowerCase();
	userBrowser.push(ub);
	if(ub == 'safari'){
		tem = (ua.match(/version\/(.{3}\d+)/i) != null) ? ua.match(/version\/(.{3}\d+)/i) : ua.match(/version\/(\d+)/i);
	}else{
		tem = ua.match(/version\/(\d+)/i);
	}
	var version  = (tem != null) ? tem[1] : (ub != 'safari') ? browser[1] : '';
	userBrowser.push(version);
	return userBrowser;
}

module.exports = {

	trackPLPClick: function(){
		var infiniteScroll = $.trim($('input[name=plp_infinitescroll]').val());
		if(infiniteScroll == 'true') {
			if (history.scrollRestoration) {
				history.scrollRestoration = 'manual';
			}
			$(window).on('scroll', function () {
				if(sessionStorage.pagedata != 'Product-Show'){
					sessionStorage.scrollPos = $(window).scrollTop();
				}
			});

			$(document).on('click','.breadcrumb-item a',function(){
				sessionStorage.setItem('scrollPos', 0);
			});
			window.addEventListener('load', function() { 
				var navAgent = browserandVersion();
				var browserDetailsArr = browserVersionPrecision(navAgent);
				var browserName = browserDetailsArr[0];
				if(browserName != 'safari' || (browserName == 'safari' && parseFloat(browserDetailsArr[1]) > 16.2)){
					sessionStorage.pagedata = $('.page').data('action');
				}
				var scrollpos = sessionStorage.getItem('scrollPos') ? sessionStorage.getItem('scrollPos') : 0;
				if (scrollpos) window.scrollTo({top: scrollpos,behavior: 'instant'});
				preExpandFilters();
			});
			window.addEventListener('unload', function(){
				sessionStorage.pagedata = $('.page').data('action');
				sessionStorage.scrollPos = $(window).scrollTop();
			});
		}
	},

	customCheckbox: function () {
		$(document).on('click', '.show-more-search', function () {
			let isHidden = $(this).data('hide');
			let seeMore = $(this).data('see-more');
			let seeLess = $(this).data('see-less');
			let seeMoreLength = parseInt($(this).data('see-more-length'), 10);
			let $refinement = $(this).closest('.refinement');

			let $refinementLi = $refinement.length ? $refinement.find('li:not(.search-hide)') : null;
			$(document).trigger('fliter:trackingViewmoreAnalytics', { dataAction: $.trim($(this).text()), dataLabel:$.trim($(this).closest('.active.refinement').find('.gtm-refinement-header').data('refinement-name')) });
			if (isHidden || isHidden === 'true') {
				$(this).data('hide', false);
				$(this).text(seeLess);
				$refinementLi.removeClass('d-none');
			} else {
				$(this).data('hide', true);
				$(this).text(seeMore);
				$refinementLi.each(function (index) {
					if (index > (seeMoreLength - 1) && !($(this).hasClass('value-selected'))) {
						$(this).addClass('d-none');
					}
				});
			}
		});
	},
	filter: function () {
		// Display refinements bar when Menu icon clicked
		$('.container').on('click', 'button.filter-results', function () {
			$('.refinement-bar, .modal-background').show();
			$('.refinement-bar').addClass('d-flex');
			$('.refinement-bar').siblings().attr('aria-hidden', true);
			$('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
			$('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
			$('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
			$('.refinement-bar .close').focus();
			$('body').addClass('noscroll');
		});
	},

	closeRefinements: function () {
		// Refinements close button
		$('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
			$('.refinement-bar, .modal-background').hide();
			$('.refinement-bar').removeClass('d-flex');
			$('.refinement-bar').siblings().attr('aria-hidden', false);
			$('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
			$('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
			$('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
			$('.btn.filter-results').focus();
			$('body').removeClass('noscroll');
		});
	},

	resize: function () {
		// Close refinement bar and hide modal background if user resizes browser
		$(window).resize(function () {
			$('.refinement-bar, .modal-background').hide();
			$('.refinement-bar').removeClass('d-flex');
			$('.refinement-bar').siblings().attr('aria-hidden', false);
			$('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
			$('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
			$('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
			$('body').removeClass('noscroll');
		});
	},

	sort: function () {
		$(document).on('sort:trackingDynamicImpression', function () {
			dynamicImpressionTracking();
		});
	},

	showMore: function () {
		// Show more products
		$('.container').on('click', '.show-more .more', function (e) {
			e.stopPropagation();
			var showMoreUrl = $(this).data('url');
			var infiniteScroll = $.trim($('input[name=plp_infinitescroll]').val());
			e.preventDefault();

			$.spinner().start();
			var browserUrl = $(this).attr('href') ? $(this).attr('href') : window.location.href;
			$(this).trigger('search:showMore', e);
			$.ajax({
				url: showMoreUrl,
				data: { selectedUrl: showMoreUrl },
				method: 'GET',
				success: function (response) {
					$('.grid-footer').replaceWith(response);
					updateSortOptions(response);
					dynamicImpressionTracking();
					if(infiniteScroll == 'true'){
						window.name = encodeURIComponent($('.product-grid.plp').html());
						var stateObj = {results: window.name};
						window.history.replaceState(stateObj, showMoreUrl, browserUrl);
						window.addEventListener('popstate', function() {
							var stateObj = {results: null};
							window.history.replaceState(stateObj, showMoreUrl, window.location.href);
						});
					} 
					else {
						window.history.pushState({}, '',browserUrl);
					}
					$.spinner().stop();
				},
				error: function () {
					$.spinner().stop();
				}
			});
		});
	},
	
	applyFilter: function () {
		// Handle refinement value selection and reset click
		$('.container').on(
			'click',
			'.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .refinements #apply-filter',
			function (e) {
				e.preventDefault();
				e.stopPropagation();

				$.spinner().start();
				$(this).trigger('search:filter', e);
				var isMobile = $(window).width() >= 769 ? false : true;
				var attributeId = '#' + $(this).find('span').last().attr('id');
				var selectedUrl = $(this).data('href');
				var filterName = $(this).data('filter-name');
				var filterCategory = $(this).data('filter-category');
				var applyFilter = $(this).attr('id') === 'apply-filter';
				if (applyFilter) {
					$('.refinement-bar button.close').trigger('click');
				}
				var browserUrl = $(this).data('browser-url');
				$.ajax({
					url: selectedUrl,
					data: {
						page: $('.grid-footer').data('page-number'),
						selectedUrl: selectedUrl
					},
					method: 'GET',
					success: function (response) {
						parseResults(response, applyFilter);
						sessionStorage.pagedata = 'Search-Show';
						var $applyFilter = $('#apply-filter:not(".disabled")');
						if ($applyFilter.length) {
							$applyFilter.attr('data-href', selectedUrl);
						}
						window.history.pushState({}, '',browserUrl);
						$(document).trigger('filter:trackingFilterAnalytics', { filterName: filterName, filterCategory: filterCategory });
						if(!isMobile) {
							window.scrollTo({ top: $('.grid-header').offset() ? $('.grid-header').offset().top : 0, behavior: 'instant' });
						}
						$.spinner().stop();
						$(attributeId).parent('button').focus();
					},
					error: function () {
						$.spinner().stop();
						$(attributeId).parent('button').focus();
					}
				});
			});
	},
	showImageVarations: function () {
		$(document).on('click', '.swatch', function (e) {
			var currentswatch = $(e.target);
			if (!currentswatch.parents('.swatch-click').hasClass('selected')) {
				//proceed only for new swatch selection			
			
				var alternateImg = $(this).attr('data-swatch-details');
				let imagePreset = $(this).attr('data-image-preset');
				var ast = JSON.parse(alternateImg);
				var newurl = ast[0].absURL;
				if (imagePreset) {
					newurl += newurl.indexOf('?') > -1 ? '&' + imagePreset : '?' + imagePreset;
				}

				var currentParent = currentswatch.parents('.product-tile');
				var imgContainer = $(currentParent).children('.image-container').children('a');
				let pdpLinkContainer = $(currentParent).find('.pdp-link').children('a');
				var mainHref = currentswatch.parents('.swatch-click').data('href');
				imgContainer.attr('href', mainHref);
				pdpLinkContainer.attr('href', mainHref);
				imgContainer.children('img').attr('src', newurl);
				currentswatch.parents('.swatches').find('.swatch-click.selected').removeClass('selected');
				currentswatch.parents('.swatch-click').addClass('selected');
				if (currentswatch.parents('.swatch-click').find('.variationame')) {
					let variantionName = currentswatch.parents('.swatch-click').find('.variationame').text();
					let $productClicklink = currentParent.find('.product-click-track');
					let gtmData = JSON.parse($productClicklink.attr('data-gtm-data'));
					gtmData.variant = $.trim(variantionName);
					$productClicklink.attr('data-gtm-data', JSON.stringify(gtmData));
				}
			}	
		});
	},
	productDetectionOnPLPLoad: function () {
		utils.enhancingSelectDropdown(true);
		dynamicImpressionTracking();	
		var infiniteScroll = $.trim($('input[name=plp_infinitescroll]').val());
		if(infiniteScroll == 'true'){
			$.spinner().start();
			if (window.history.state != null) {
				(window.history.state.results != null) ? $('.product-grid.plp').html(decodeURIComponent(window.history.state.results)) : '';
			}
			setTimeout(function() { $.spinner().stop(); }, 900);
		}																	
	},
	showContentTab: function () {
		// Display content results from the search
		$('.container').on('click', '.content-search', function () {
			if ($('#content-search-results').html() === '') {
				getContent($(this), $('#content-search-results'));
			}
		});

		// Display the next page of content results from the search
		$('.container').on('click', '.show-more-content button', function () {
			getContent($(this), $('#content-search-results'));
			$('.show-more-content').remove();
		});
	},
	SortHideDropdown: function () {
		$(document).click(function (e) {
			if (
				!$(e.target).closest('.custom-dropdown__options').length &&
                !$(e.target).closest('.custom-dropdown__selected').length && $('.custom-dropdown__optionsWrapper.custom-dropdown-active').length
			) {
				$('.custom-dropdown__selected--text').click();
			}
		});
	},
	PLPBackButtonPreviousStage: function () {
		window.addEventListener('popstate', function () {
			var infiniteScroll = $.trim($('input[name=plp_infinitescroll]').val());
			if(infiniteScroll == 'true'){
				var navAgent = browserandVersion();
				var browserDetailsArr = browserVersionPrecision(navAgent);
				var browserName = browserDetailsArr[0];
				if(browserName != 'safari' || (browserName == 'safari' && parseFloat(browserDetailsArr[1]) > 16.2) || sessionStorage.pagedata == 'Search-Show') {
					window.name = '';
					sessionStorage.scrollPos = 0;
					window.scrollTo({ top: 0, behavior: 'instant' });
					var stateObj = {results: null};
					window.history.replaceState(stateObj, '', window.location.href);
					location.reload();
				}else {
					sessionStorage.pagedata = 'Search-Show';
				}	
			}else{
				location.reload();
			}	
		});
	}
};

function preExpandFilters(){
	var isMobile = $('#isMobile').length > 0 ? $('#isMobile').val() : false;
	if(isMobile !== 'true'){
		$('.refinements .refinement').slice(0,3).addClass('active');
	}else{
		$('.refinements .refinement').hasClass('active') ? $('.refinements .refinement').removeClass('active') : '';
	}
}